/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../app/@shared/ui/modal/modal.component.ngfactory';
import * as i2 from '../../app/@shared/ui/modal/modal.component';
import * as i3 from '../../app/@shared/ui/modal/modal.service';
import * as i4 from '../../compat/compat.component';
const styles_CompatComponent:any[] = ([] as any[]);
export const RenderType_CompatComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CompatComponent,data:{}});
export function View_CompatComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{entryPoint:0}),(_l()(),i0.ɵted((null as any),
      ['\n    '])),(_l()(),i0.ɵeld(16777216,[[1,3],['entryPoint',1]],(null as any),
      0,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),1,'fl-modal',([] as any[]),(null as any),(null as any),
      (null as any),i1.View_ModalComponent_0,i1.RenderType_ModalComponent)),i0.ɵdid(114688,
      (null as any),0,i2.ModalComponent,[i3.ModalService,[1,i0.Injector]],(null as any),
      (null as any)),(_l()(),i0.ɵted((null as any),['\n  ']))],(_ck,_v) => {
    _ck(_v,5,0);
  },(null as any));
}
export function View_CompatComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'webapp-compat',
      ([] as any[]),(null as any),(null as any),(null as any),View_CompatComponent_0,
      RenderType_CompatComponent)),i0.ɵdid(114688,(null as any),0,i4.CompatComponent,
      [[1,i0.Injector],i0.NgModuleFactoryLoader],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CompatComponentNgFactory:i0.ComponentFactory<i4.CompatComponent> = i0.ɵccf('webapp-compat',
    i4.CompatComponent,View_CompatComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkLXdlYmFwcC1jb21wYXQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC13ZWJhcHAtY29tcGF0L3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC13ZWJhcHAtY29tcGF0L3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMuQ29tcGF0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC13ZWJhcHAtY29tcGF0L3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMuQ29tcGF0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPG5nLWNvbnRhaW5lciAjZW50cnlQb2ludD48L25nLWNvbnRhaW5lcj5cbiAgICA8ZmwtbW9kYWw+PC9mbC1tb2RhbD5cbiAgIiwiPHdlYmFwcC1jb21wYXQ+PC93ZWJhcHAtY29tcGF0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O3dEQ0FBO01BQUEsYUFDSTtNQUFBO01BQUEsZ0JBQXlDLDJDQUN6QztNQUFBO01BQUEsNkVBQUE7TUFBQTtNQUFBLGVBQXFCO0lBQXJCOzs7O29CQ0ZKO01BQUE7Z0NBQUEsVUFBQTtNQUFBOztJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/$$_gendir/compat/compat.component.ngfactory.ts